import { MAX_TAG_LENGTH, MAX_TAGS } from "../constants/tag-constraints"

export function normalizeTag(value: string): string {
  return Array.from(value.trim().toLowerCase())
    .slice(0, MAX_TAG_LENGTH)
    .join("")
}

export function normalizeTags(
  tags: readonly string[],
  maxTags: number = MAX_TAGS,
): string[] {
  const seenTags = new Set<string>()
  const normalizedTags: string[] = []

  for (const rawTag of tags) {
    const tag = normalizeTag(rawTag)
    if (!tag || seenTags.has(tag)) {
      continue
    }

    seenTags.add(tag)
    normalizedTags.push(tag)

    if (normalizedTags.length >= maxTags) {
      return normalizedTags
    }
  }

  return normalizedTags
}

export function parseTagFilterParam(
  value: string | string[] | undefined,
): string[] {
  const rawValues = Array.isArray(value) ? value : value ? [value] : []
  return normalizeTags(
    rawValues.flatMap((rawValue) =>
      rawValue.split(",").map((tag) => {
        try {
          return decodeURIComponent(tag)
        } catch {
          return tag
        }
      }),
    ),
  )
}

export function formatTagFilterParam(tags: readonly string[]): string | null {
  const normalizedTags = normalizeTags(tags)
  return normalizedTags.length > 0
    ? normalizedTags.map(encodeURIComponent).join(",")
    : null
}
